import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {DataService} from 'src/app/_services/data.service';
import {Subscription} from "rxjs";

@Component({
    selector: 'app-how-much-rooms',
    templateUrl: './how-much-rooms.component.html',
    styleUrls: ['./how-much-rooms.component.scss']
})
export class HowMuchRoomsComponent implements OnInit, OnDestroy {


    @Input() public building;
    @Output() public currentRoomAmount = new EventEmitter();
    private curBuildingSubscription: Subscription;
    currentNumber: any;
    browserLang: string;

    constructor(private translate: TranslateService, public dataService: DataService) {
    }

    ngOnInit(): void {
        this.browserLang = this.translate.getBrowserLang();
        this.curBuildingSubscription = this.dataService.curBuilding.subscribe(item => {
            this.building = item;
            // this.dataService.saveCurBuilding(item);
        })
        setTimeout(() => {
            // this.currentNumber= this.translate.instant('ROOMS');
            this.currentNumber = '';
        }, 1000);
    }

    howMuchRooms(numOfRooms, event) {
        // let siblings = event.target.parentNode.childNodes;
        // for (let i = 0; i < siblings.length; i++) {
        //   if (siblings[i].classList !== undefined) {
        //     siblings[i].classList.remove("current");
        //   }
        // }
        // event.srcElement.classList.add("current");
        this.currentRoomAmount.emit(numOfRooms);
        // if(event.target.textContent === ""){
        //   this.currentNumber = this.translate.instant('ROOMS');
        // } else {
        //   this.currentNumber = event.target.textContent;
        // }

        this.currentNumber = event.target.textContent;
        if (numOfRooms === 0) {
            this.currentNumber = "";
        }
        // this.howMuchRoomsHighlight = numOfRooms;
    }

    ngOnDestroy() {
        this.curBuildingSubscription && this.curBuildingSubscription.unsubscribe();
    }
}
